import { StaleTime, useQuery } from '@tanstack/react-query';
import { getConversation } from '../../services/chats';
import useUser from '../global/useUser';

interface Options {
  enabled?: boolean;
  staleTime?: StaleTime<any, any>;
}

function useGetConversation(
  conversationId: string | null | undefined,
  { enabled = true, staleTime }: Options = {},
) {
  const { user } = useUser();

  const { data, isFetching, isLoading, isError, error, refetch } = useQuery({
    queryKey: [
      'chat-conversation',
      user?.userId,
      user?.business?.id,
      conversationId,
    ],
    queryFn: async () => {
      const result = await getConversation(conversationId!);
      return result;
    },
    enabled:
      !!conversationId && !!user?.userId && !!user?.business?.id && enabled,
    staleTime,
  });

  return {
    conversation: data,
    isFetching,
    isLoading,
    isError,
    error,
    refetch,
  };
}

export default useGetConversation;
